import { GET_ID_INDIVIDUAL_CLEAR_VERFIDATION_URL, GET_ID_INDIVIDUAL_VERFICATION_URL, GET_INDIVIDUAL_LIST, INDIVIDUAL_USER_PASSWORDRESET_URL, BULK_ATOM_ID_LOOKUP_URL } from "../../../config/adminUrlConfig";
import { ApiService } from "../../../config/apiServices";

export const getIndividaulList = (perPage,currentPage,selectedStatus,searchData,selectedDistrictId,selectedCategory,selectedSubCategoryId,selectedSportId = "") => {
    return ApiService.get(`${GET_INDIVIDUAL_LIST}?number=${perPage}&page=${currentPage}&status=${selectedStatus}&search=${searchData}&city=${selectedDistrictId}&category_type=${selectedCategory}&sub_category_type=${selectedSubCategoryId}&sport_id=${selectedSportId}`);
};

export const getAllDataIndividaulList = (selectedStatus,searchData,selectedDistrictId,selectedSubCategoryId,selectedSportId) => {
    return ApiService.get(`${GET_INDIVIDUAL_LIST}?&status=${selectedStatus}&search=${searchData}&city=${selectedDistrictId}&sub_category_type=${selectedSubCategoryId}&sport_id=${selectedSportId}`);
};

export const getAllRegistrationList = (perPage, currentPage, searchData, selectedDistrictId, selectedCategory, selectedSubCategoryId, selectedSportId, dobYear, selectedBlockId) => {
    const params = new URLSearchParams();
    params.append("number", perPage);
    params.append("page", currentPage);
    params.append("search", searchData || "");
    params.append("city", selectedDistrictId || "");
    params.append("block", selectedBlockId || "");
    params.append("category_type", selectedCategory || "");
    params.append("sub_category_type", selectedSubCategoryId || "");
    params.append("sport_id", selectedSportId || "");
    if (dobYear !== undefined && dobYear !== "") {
        params.append("dob_year", dobYear);
    }
    return ApiService.get(`${GET_INDIVIDUAL_LIST}?${params.toString()}`);
};


export const getIndividualVerfiedByID = (Id) => {
    return ApiService.get(`${GET_ID_INDIVIDUAL_VERFICATION_URL}${Id}`);
}


export const clearIndividualVerfication = (data) => {
    return ApiService.post(GET_ID_INDIVIDUAL_CLEAR_VERFIDATION_URL,data);
};

export const resetIndividualUserPassword = (userId, payload) => {
    return ApiService.post(`${INDIVIDUAL_USER_PASSWORDRESET_URL}/${userId}`, payload);
};

export const bulkAtomIdLookup = (atomIds) => {
    return ApiService.post(BULK_ATOM_ID_LOOKUP_URL, { atom_ids: atomIds });
};